/**
 * @file CartFields.tsx
 * @description Обёртка полей группы «Вида корзины» (phase19.16, SB120 этап 4;
 * uiux-cart §7 «Только просмотр»): без права THEME `fieldset disabled` гасит
 * все кнопки и поля группы разом — они видны, но не нажимаются (прецедент —
 * BlogCoverFields). Сворачивание групп остаётся рабочим: оно вне обёртки.
 */

import type { ReactNode } from "react";

import { useCartLook } from "./cart-look-context";

export function CartFields({ children }: { children: ReactNode }) {
  const { readOnly } = useCartLook();
  return (
    <fieldset disabled={readOnly} className="m-0 flex min-w-0 flex-col gap-3 border-0 p-0">
      {children}
    </fieldset>
  );
}
